var map = {
	"./formatDate.js": "c5ad",
	"./formatDateTime.js": "6de4",
	"./formatMoney.js": "34c2",
	"./index.js": "89753",
	"./snippet.js": "717d",
	"./uppercase.js": "90df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d25";